import React, { useState, useEffect, useRef } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  TextField,
  Snackbar,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Home from "./pages/Home";
import emailjs from '@emailjs/browser';

const Modalpopup = () => {
  const [open, setOpen] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const form = useRef();

  useEffect(() => {
    openPopup(); // Call function to open the popup when component mounts
  }, []); // Empty dependency array means it only runs once when component mounts

  const openPopup = () => {
    setOpen(true);
  };

  const closePopup = () => {
    setOpen(false);
    window.location.href = '/';
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm('service_x27urq8', 'template_j9odewc', form.current, 'uTJkJ0Joo3Q5RO4FE')
      .then(
        () => {
          setSnackbarMessage('Submission successful!');
          setSnackbarOpen(true);
          closePopup();
        },
        (error) => {
          setSnackbarMessage(`Submission failed: ${error.text}`);
          setSnackbarOpen(true);
        },
      );
  };

  return (
    <>
      <Home />
      <div style={{ textAlign: 'center' }}>
        <Dialog
          open={open}
          onClose={closePopup}
          fullWidth
          maxWidth="sm"
        >
        <DialogTitle>
            Send Your Message
            <IconButton onClick={closePopup} style={{ float: 'right' }}>
              <CloseIcon color="primary" />
            </IconButton>
        </DialogTitle>
        <DialogContent>
            <form ref={form} onSubmit={sendEmail}>
              <Stack spacing={2} margin={2}>
                <TextField variant="outlined" label="Name" name="user_name" />
                <TextField variant="outlined" label="Contact Number" name="contact_number" />
                <TextField variant="outlined" label="Email" name="user_email" />
                <TextField variant="outlined" label="Message" name="message" multiline rows={4} />
                <Button type="submit" color="primary" variant="contained">
                  Submit
                </Button>
              </Stack>
            </form>
        </DialogContent>
        <DialogActions>
            {/* Optional buttons can be added here */}
        </DialogActions>
        </Dialog>
        <Snackbar
          open={snackbarOpen}
          autoHideDuration={30000}
          onClose={handleSnackbarClose}
          message={snackbarMessage}
          action={
            <Button color="inherit" size="small" onClick={handleSnackbarClose}>
              Close
            </Button>
          }
          />
      </div>
    </>
  );
};

export default Modalpopup;
